import { useNavigate } from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import CardHeader from '@/shared-components/cards/components/CardHeader';
import ArtworkRatingDisplayer from '@/shared-components/inputs/components/ArtworkRatingDisplayer';
import { hasRenderableRating } from '@/utils/activityContent';
import { resolveFollowState } from '@/utils/followState';

// import Utils from '@/utils';
import './styles/ArtworkInlineTitle.css';
import './styles/ProfileRatingCard.css';

export default function ProfileRatingCard({ data, ratingUser }) {
  const navigate = useNavigate();
  const { cacheHandler } = useStateHandler();
  const revealRatingEntry = {
    _id: data?._id ?? null,
    createdAt: data?.createdAt ?? null,
    rating_values: data?.rating_values ?? null,
    rating_creator: ratingUser ?? data?.rating_creator ?? null,
  };

  if (!hasRenderableRating(data)) {
    return null;
  }
  const isFollowing = resolveFollowState({ cacheHandler, userId: ratingUser?._id, imFollowing: ratingUser?.im_following });

  return (
    <>
      <div
        className={`profile-rating-card__container ${isFollowing ? 'following' : ''}`}
        onClick={() => navigate(`/artwork/${data.rating_artwork.slug}?rate=true`, {
          state: {
            from: true,
            artworkViewSource: {
              type: 'community',
              label: '',
            },
            revealRatingEntry,
          }
        })}
      >
        <CardHeader
          image={ratingUser.user_image?.image_id}
          profileType={ratingUser.user_type}
          username={ratingUser.user_username}
          onUserClick={() => navigate(`/user/${ratingUser.user_username}`)}
          className="profile-rating-card__card-header"
          subtitle={
            <>on <span className="artwork-inline-title">{data.rating_artwork.artwork_about.artwork_title}</span></>
          }
        />

        <div className="profile-rating-card__rating-section">
          <div className="profile-rating-card__ratings">
            <ArtworkRatingDisplayer
              className="profile-rating-card__rating"
              category="Emotions"
              username={ratingUser.user_username}
              userRating={data.rating_values.emotions}
              myRating={data.my_rating.rating_values.emotions}
            />

            <ArtworkRatingDisplayer
              className="profile-rating-card__rating"
              category="Style"
              username={ratingUser.user_username}
              userRating={data.rating_values.style}
              myRating={data.my_rating.rating_values.style}
            />

            <ArtworkRatingDisplayer
              className="profile-rating-card__rating"
              category="Time travel"
              username={ratingUser.user_username}
              userRating={data.rating_values.time_travel}
              myRating={data.my_rating.rating_values.time_travel}
            />
          </div>

          <ArtworkImage
            image={data.rating_artwork.artwork_media.artwork_main_picture.image_id}
            imageClassName="profile-rating-card__artwork-image"
            imageTemplateClassName="profile-rating-card__artwork-image"
            forceSmaller={300}
          />
        </div>
      </div>
    </>
  );
}
